<template>
    <a-tree-select
        :get-popup-container="getPopupContainer"
        placeholder="请选择"
        :value="value"
        :tree-data="treeData"
        show-search
        allow-clear
        tree-default-expand-all
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        @update:value="onUpdateValue"
        style="width: 100%"
    />
</template>

<script>
import {computed} from "vue";

const
    titleField = "title",
    valueField = "value",
    parentField = "parentId",
    rootValue = 1628606141145972737;

export default {
    name: "TreeSingleSelect",
    emits: ["update:value"],
    props: {
        value: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        titleField: {
            type: String,
            default: titleField,
        },
        valueField: {
            type: String,
            default: valueField,
        },
        dataField:{
            type: String,
            default: null,
        },
        parentField: {
            type: String,
            default: parentField,
        },
        rootValue: {
            type: [Number, String],
            default: rootValue,
        },
        showRoot: {
            type: Boolean,
            default: true,
        }
    },
    setup(props, {emit}) {
        // 定义了方法

        const getTreeData = (
            {
                datas = [],
                titleField = titleField,
                valueField = valueField,
                dataField = valueField,
                parentField = parentField,
                rootValue = rootValue,
            }
        ) => {
            // 转化树形结构
            let convertData = (datas, rootValue) => {
                let list = datas
                    .filter((v) => {
                        return v[parentField] === rootValue;
                    })
                    .map((v) => {
                        return {
                            key: v[dataField],
                            title: v[titleField],
                            value: v[valueField],
                        };
                    });

                list.forEach((v) => {
                    v.children = convertData(datas, v.key);
                });
                return list;
            };

            return convertData(datas, rootValue);
        };

        const treeData = computed(() => {
            console.log(props.dataField,'props.dataField')
            let treeData = getTreeData({
                datas: props.options,
                titleField: props.titleField,
                valueField: props.valueField,
                dataField: props.dataField || props.valueField,
                parentField: props.parentField,
                rootValue: props.rootValue,
            })
            console.log(treeData,'treeData')
            if (props.showRoot) {
                treeData.unshift(
                    {key: props.rootValue, title: '根级', value: props.rootValue,},
                )
            }
            return treeData
        });

        const onUpdateValue = (value) => {
            emit("update:value", value);
        };
        return {
            treeData,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
